import React from "react";
import { Dialog } from "primereact/dialog";

interface LogoModalProps {
  visible: boolean;
  onHide: () => void;
  logo: string;
  provider: string;
}

export const LogoModal: React.FC<LogoModalProps> = ({
  visible,
  onHide,
  logo,
  provider,
}) => {
  return (
    <Dialog
      header={`Logo - ${provider}`}
      visible={visible}
      style={{ width: "90vw", maxWidth: "600px" }}
      onHide={onHide}
    >
      <div className="flex justify-content-center align-items-center p-4">
        {logo && (
          <img 
            src={logo} 
            alt={`Logo de ${provider}`}
            className="border-round shadow-2"
            style={{ 
              maxWidth: '100%', 
              maxHeight: '400px', 
              objectFit: 'contain',
              border: '1px solid #e0e0e0'
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
              (e.target as HTMLImageElement).nextElementSibling!.textContent = 'Error al cargar la imagen';
            }}
          />
        )}
        <span style={{ display: 'none' }} className="text-red-500"></span>
      </div>
    </Dialog>
  );
}; 